import React, { useState } from 'react';
import { Text, TouchableOpacity, StyleSheet, Pressable } from 'react-native';

const CancelButton = ({ onPress, disabled = false, text }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Pressable onHoverIn={() => setHovered(true)} onHoverOut={() => setHovered(false)}>
      <TouchableOpacity onPress={onPress} style={[styles.button, hovered && !disabled && styles.buttonHovered]} disabled={disabled}>
        <Text style={[styles.text, hovered && styles.textHovered, disabled && styles.disabledState]}>{text}</Text>
      </TouchableOpacity>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 9999,
    backgroundColor: 'transparent',
    borderWidth:1,
    borderColor:'transparent',
    transition: 'all 0.2s ease'
  },
  buttonHovered: {
    backgroundColor: '#eaf3ff',
    borderColor:'#badfff'
  },
  text: {
    color: '#2f78d0',
    fontWeight: '600',
    fontSize: 14,
    fontWeight: '500'
  },
  textHovered: {
    color: '#2f78d0'
  },
  disabledState: {
    color: '#a1a1aa'
  }
});

export default CancelButton;
